/* BeautiQ — zwei Lumèra kreisen beim Scrollen umeinander.
   Die Bewegungskurve entspricht der Vorlage: Kreisbahn in der XY-Ebene,
   Tiefenwechsel, Neigung und ein wanderndes Licht auf dem Gehäuse.
   Braucht kein 3D und keine Bibliothek. */
(function () {
  "use strict";

  var section = document.querySelector("[data-showcase]");
  if (!section) return;

  var stage = section.querySelector("[data-orbit]");
  var a = section.querySelector('[data-orb="a"]');
  var b = section.querySelector('[data-orb="b"]');
  var modeEls = section.querySelectorAll(".mode");
  var progEls = section.querySelectorAll(".progress i");
  var halo = section.querySelector(".orbit-halo");
  if (!stage || !a || !b) return;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var clamp = function (v, min, max) { return Math.min(max, Math.max(min, v)); };
  var smooth = function (v) { return v * v * (3 - 2 * v); };

  /* ---- Modusanzeige ---- */
  var lastMode = -1;
  function setMode(i) {
    if (i === lastMode || !modeEls.length) return;
    lastMode = i;
    for (var j = 0; j < modeEls.length; j++) {
      modeEls[j].classList.toggle("act", j === i);
      if (progEls[j]) progEls[j].classList.toggle("on", j <= i);
    }
    if (halo) {
      var c = modeEls[i].getAttribute("data-color") || "#C8A96A";
      halo.style.setProperty("--halo", c);
    }
  }
  setMode(0);

  /* ---- Das Gerät maskiert seinen eigenen Lichtreflex ---- */
  var imgA = a.querySelector("img"), imgB = b.querySelector("img");
  var setMask = function (orb, img) {
    if (img && img.getAttribute("src")) {
      /* Absolut auflösen: die Maske wird im Stylesheet benutzt und würde sonst
         relativ zur CSS-Datei statt zum Dokument aufgelöst. */
      var u = img.getAttribute("src");
      try { u = new URL(u, document.baseURI).href; } catch (e) {}
      orb.style.setProperty("--shine-mask", 'url("' + u + '")');
    }
  };
  setMask(a, imgA);
  setMask(b, imgB);

  /* ---- Farbwähler: tauscht die beiden Ausführungen ---- */
  var picker = section.querySelector("[data-colorpick]");
  if (picker) {
    var swap = function (orb, img, src) {
      if (!src || !img || img.getAttribute("src") === src) return;
      img.style.opacity = "0";
      var pre = new Image();
      pre.onload = function () { img.src = src; img.style.opacity = ""; setMask(orb, img); };
      pre.onerror = function () { img.style.opacity = ""; };
      pre.src = src;
    };
    var btns = picker.querySelectorAll("button");
    [].forEach.call(btns, function (btn, i) {
      btn.addEventListener("click", function () {
        [].forEach.call(btns, function (o, j) { o.classList.toggle("on", j === i); });
        swap(a, imgA, btn.getAttribute("data-a"));
        swap(b, imgB, btn.getAttribute("data-b"));
      });
      btn.addEventListener("keydown", function (e) {
        if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
        e.preventDefault();
        var n = (i + (e.key === "ArrowRight" ? 1 : btns.length - 1)) % btns.length;
        btns[n].focus(); btns[n].click();
      });
    });
  }

  if (reduce) { stage.classList.add("static"); return; }

  /* ---- Kreisbahn ---- */
  var ticking = false;

  function render() {
    ticking = false;

    var rect = section.getBoundingClientRect();
    var travel = Math.max(1, section.offsetHeight - window.innerHeight);
    var progress = smooth(clamp(-rect.top / travel, 0, 1));

    var angle = progress * Math.PI * 2 - 0.42;
    var radiusX = Math.min(stage.clientWidth * 0.22, 250);
    var radiusY = Math.min(stage.clientHeight * 0.075, 68);

    var sin = Math.sin(angle);
    var ax = Math.cos(angle) * radiusX;
    var ay = sin * radiusY;
    var aFront = sin > 0;
    var tilt = sin * 6;

    var refA = (Math.sin(angle + 0.38) + 1) / 2;
    var refB = (Math.sin(angle + Math.PI + 0.38) + 1) / 2;
    var refOp = function (v) { return (0.07 + (1 - Math.abs(v - 0.5) * 2) * 0.18).toFixed(3); };

    a.style.transform =
      "translate3d(calc(-50% + " + ax + "px),calc(-50% + " + ay + "px)," + (aFront ? 90 : -30) + "px)" +
      " rotateY(" + tilt + "deg) rotateZ(" + (-8 + sin * 7 + progress * 5) + "deg)" +
      " scale(" + (aFront ? 1.045 : 0.97) + ")";
    b.style.transform =
      "translate3d(calc(-50% + " + (-ax) + "px),calc(-50% + " + (-ay) + "px)," + (aFront ? -30 : 90) + "px)" +
      " rotateY(" + (-tilt) + "deg) rotateZ(" + (8 - sin * 7 - progress * 5) + "deg)" +
      " scale(" + (aFront ? 0.97 : 1.04) + ")";

    a.style.setProperty("--shine-position", refA * 100 + "%");
    b.style.setProperty("--shine-position", refB * 100 + "%");
    a.style.setProperty("--shine-opacity", refOp(refA));
    b.style.setProperty("--shine-opacity", refOp(refB));
    a.style.zIndex = aFront ? "4" : "2";
    b.style.zIndex = aFront ? "2" : "4";

    /* Modi laufen im ruhigen Mittelteil durch, nicht schon beim Anschneiden */
    var span = clamp((progress - 0.08) / 0.8, 0, 1);
    setMode(Math.min(modeEls.length - 1, Math.floor(span * (modeEls.length - 0.001))));
  }

  function request() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(render);
  }

  window.addEventListener("scroll", request, { passive: true });
  window.addEventListener("resize", request);
  window.addEventListener("load", request);
  render();
})();
